import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseAutoCompleteWithSingleSelectedItem from '@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue';
import Api from '@/services/api/ApiServiceFabrick';
import getOperationOffice from '@/types/responses/getOperationOffice';
import getVehicleResponse from '@/types/responses/getVehicle';
import { onMounted, ref, watch } from 'vue';
import i18n from '@/lang/i18n';

type ItemType = {
  id: number;
  name: string;
  operationOfficeId: number;
  vehicle: getVehicleResponse;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'DigitalTacographFWCopyAutoComplete',
  props: {
    modelValue: {},
    initialItemId: {},
    operationOffice: {},
    errorMessages: {},
    readonly: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit;

const selectedItem = ref<ItemType | undefined>(undefined);
const items = ref<ItemType[]>([]);

onMounted(async () => {
  await getItems();
  selectedItem.value = items.value.find(
    (item) => item.id === props.initialItemId
  );
});

// operationOfficeが変更された時にitemsを更新する
watch(
  () => props.operationOffice,
  () => {
    getItems();
  }
);

// initialItemIdが変更された時にselectedItemを更新する
watch(
  () => props.initialItemId,
  () => {
    selectedItem.value = items.value.find(
      (item) => item.id === props.initialItemId
    );
  }
);

// selectedItemがitemsに含まれていない場合は選択を解除する
watch(
  () => items.value,
  () => {
    selectedItem.value = items.value.find(
      (item) => item.id === selectedItem.value?.id
    );
  }
);

// 変更を親コンポーネントに伝える
watch(
  () => selectedItem.value,
  (newValue) => {
    emit('update:modelValue', newValue);
  }
);

const getItems = async () => {
  if (!props.operationOffice) {
    items.value = [];
    return;
  }

  const params = {
    status: 'all',
    operation_office_id: props.operationOffice.id,
  };

  const [devices, vehicles] = await Promise.all([
    Api().autoComplete.devices(params, true),
    Api().autoComplete.vehicles(params, true),
  ]);

  const itemsTmp: ItemType[] = [];

  devices.forEach((device) => {
    const vehicle = vehicles.find(
      (vehicle) => vehicle.digital_tacograph === device.id
    );

    if (vehicle === undefined || device.status) {
      return;
    }

    itemsTmp.push( {
      id: device.id,
      name: device.device_id,
      operationOfficeId: device.operation_office_id,
      vehicle,
    });
  });

  items.value = itemsTmp;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseAutoCompleteWithSingleSelectedItem, {
    modelValue: selectedItem.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedItem).value = $event)),
    label: _unref(i18n).global.t('pages.vehicles.form.firmwareSettingCopy'),
    itemName: "name",
    items: items.value,
    "operation-offices": 
      __props.operationOffice === undefined ? undefined : [__props.operationOffice]
    ,
    "error-messages": __props.errorMessages,
    disabled: __props.disabled
  }, null, 8, ["modelValue", "label", "items", "operation-offices", "error-messages", "disabled"]))
}
}

})